import React from 'react';
import { Link } from 'react-router-dom';
import { getFileUrl } from '../lib/api';
import { Clock } from 'lucide-react';

const fmt = (d) => new Date(d).toLocaleDateString('es-ES',{day:'numeric',month:'short',year:'numeric'});
const img = (u,fb) => !u ? fb : u.startsWith('http') ? u : getFileUrl(u);
const statusLabel = (s) => s==='pending'?'PENDIENTE':s==='approved'?'APROBADA':'RECHAZADA';

const FB1 = 'https://images.unsplash.com/photo-1675190282312-b87810694d0d?w=800&q=80';
const FB2 = 'https://images.unsplash.com/photo-1650984661525-7e6b1b874e47?w=500&q=80';

export function NewsCardHero({news}) {
  return (
    <Link to={`/news/${news.id}`} data-testid={`news-hero-${news.id}`}
      className="group relative block overflow-hidden col-span-full lg:col-span-8 row-span-2 min-h-[450px] lg:min-h-[550px] border-2 border-[#0B1F40] brutal-shadow-hover brutal-btn-press transition-all">
      <img src={img(news.image_url,FB1)} alt={news.title} className="absolute inset-0 w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-500 group-hover:scale-[1.03]"/>
      <div className="absolute inset-0 bg-gradient-to-t from-[#0B1F40] via-[#0B1F40]/30 to-transparent"/>
      <div className="absolute top-4 left-4 bg-[#E50B15] text-white text-[10px] font-black tracking-[0.2em] uppercase px-3 py-1.5">{news.category}</div>
      <div className="absolute bottom-0 left-0 right-0 p-6 lg:p-10">
        <h2 className="text-white text-2xl sm:text-4xl lg:text-5xl tracking-tighter leading-none mb-3" style={{fontFamily:'Archivo Black'}}>{news.title}</h2>
        <div className="flex items-center gap-3 text-white/60 text-xs font-medium">
          <span className="text-white/90 font-bold">{news.author_name}</span>
          <span className="w-1 h-1 bg-[#E50B15]"/>
          <span className="flex items-center gap-1"><Clock className="h-3 w-3"/>{fmt(news.created_at)}</span>
        </div>
      </div>
    </Link>
  );
}

export function NewsCardSmall({news,className=''}) {
  return (
    <Link to={`/news/${news.id}`} data-testid={`news-card-${news.id}`}
      className={`group block border-2 border-[#0B1F40]/15 hover:border-[#0B1F40] brutal-shadow-hover brutal-btn-press transition-all bg-white ${className}`}>
      <div className="aspect-[16/10] overflow-hidden border-b-2 border-[#0B1F40]/15">
        <img src={img(news.image_url,FB2)} alt={news.title} className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-500 group-hover:scale-105"/>
      </div>
      <div className="p-4">
        <div className="text-[10px] font-black tracking-[0.2em] uppercase text-[#E50B15] mb-1">{news.category}</div>
        <h3 className="text-sm font-black text-[#0B1F40] leading-snug mb-2 group-hover:text-[#E50B15] transition-colors" style={{fontFamily:'Archivo Black'}}>{news.title}</h3>
        <p className="text-xs text-[#0B1F40]/50 line-clamp-2 mb-3">{news.summary}</p>
        <div className="flex items-center justify-between text-[10px] text-[#0B1F40]/40 border-t border-[#0B1F40]/10 pt-2">
          <span className="font-bold text-[#0B1F40]/60">{news.author_name}</span>
          <span className="flex items-center gap-1"><Clock className="h-2.5 w-2.5"/>{fmt(news.created_at)}</span>
        </div>
      </div>
    </Link>
  );
}

export function NewsCardAdmin({news,onApprove,onReject}) {
  const sc = {pending:'border-l-amber-500 bg-amber-50',approved:'border-l-emerald-600 bg-emerald-50',rejected:'border-l-[#E50B15] bg-red-50'};
  return (
    <div data-testid={`admin-news-${news.id}`} className={`border-2 border-[#0B1F40]/10 border-l-4 p-4 flex items-start justify-between gap-4 ${sc[news.status]||''}`}>
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2 mb-1">
          <span className="text-[10px] font-black tracking-[0.15em] uppercase text-[#0B1F40]/60">{statusLabel(news.status)}</span>
          <span className="text-[10px] font-bold text-[#E50B15]">{news.category}</span>
        </div>
        <h4 className="font-black text-sm text-[#0B1F40] truncate" style={{fontFamily:'Archivo Black'}}>{news.title}</h4>
        <p className="text-xs text-[#0B1F40]/40 mt-1">Por {news.author_name} — {fmt(news.created_at)}</p>
      </div>
      {news.status==='pending'&&(
        <div className="flex gap-2 shrink-0">
          <button data-testid={`approve-btn-${news.id}`} onClick={()=>onApprove(news.id)} className="px-4 py-1.5 bg-emerald-600 text-white text-xs font-black brutal-btn-press transition-all" style={{boxShadow:'3px 3px 0px #0B1F40'}}>APROBAR</button>
          <button data-testid={`reject-btn-${news.id}`} onClick={()=>onReject(news.id)} className="px-4 py-1.5 bg-[#E50B15] text-white text-xs font-black brutal-btn-press transition-all" style={{boxShadow:'3px 3px 0px #0B1F40'}}>RECHAZAR</button>
        </div>
      )}
    </div>
  );
}
